// extracted by mini-css-extract-plugin
export var footerBottom = "FooterBottom-module--footerBottom--a2b56";